import _ from '../../../utils/lodash';
import { parseDateUtc, getSchedulerModeTimes } from '../../../utils/dates';
import { AssignmentVisitState } from '../../../enums';

const isValidRangePeriod = (start, end, startRangeDate, endRangeDate) =>
  parseDateUtc(start).isBetween(startRangeDate, endRangeDate, null, '[)') ||
  parseDateUtc(end).isBetween(startRangeDate, endRangeDate, null, '(]') ||
  (parseDateUtc(start).isBefore(startRangeDate) && parseDateUtc(end).isAfter(endRangeDate));

const filteredPostingsBySchedulerModeView = (
  postings,
  isNightMode,
  selectedDate,
  schedulerModeStartTime,
  schedulerModeEndTime,
) => {
  const { schedulerStartTime, schedulerEndTime } = getSchedulerModeTimes(
    selectedDate,
    isNightMode,
    schedulerModeStartTime,
    schedulerModeEndTime,
  );
  const schedulerModeStartTimeObject = parseDateUtc(schedulerStartTime);
  const schedulerModeEndTimeObject = parseDateUtc(schedulerEndTime);

  return _.filter(postings, p => {
    p.availabilities = _.filter(p.availabilities, a => {
      a.assignments = _.filter(a.assignments, assignment => {
        const { startDate, endDate, visitStatus, visualStartDate, visualEndDate } = assignment;
        const isEarlyCompleted =
          visitStatus === AssignmentVisitState.Complete || visitStatus === AssignmentVisitState.Complete;
        const startTime = isEarlyCompleted ? visualStartDate : startDate;
        const endTime = isEarlyCompleted ? visualEndDate : endDate;

        const isValid = isValidRangePeriod(
          startTime,
          endTime,
          schedulerModeStartTimeObject,
          schedulerModeEndTimeObject,
        );
        return isValid;
      });

      const isValidAvailability = isValidRangePeriod(
        a.startDate,
        a.endDate,
        schedulerModeStartTimeObject,
        schedulerModeEndTimeObject,
      );
      a.startDate =
        parseDateUtc(a.startDate).diff(schedulerModeStartTimeObject, 'minutes') <= 0 ? schedulerStartTime : a.startDate;

      return isValidAvailability || a.assignments.length > 0;
    });

    return p.workingTime.hours > 0 || p.workingTime.minutes > 0;
  });
};

export const filterResponseBySchedulerModeView = (
  response,
  isNightMode,
  selectedDate,
  schedulerModeStartTime,
  schedulerModeEndTime,
) => {
  const {
    data: { postings },
  } = response;
  const filteredPostings = filteredPostingsBySchedulerModeView(
    postings,
    isNightMode,
    selectedDate,
    schedulerModeStartTime,
    schedulerModeEndTime,
  );

  return { ...response, data: { ...response.data, postings: filteredPostings } };
};
